import React, { useState } from "react"
import PropTypes from "prop-types"
import { Progress } from "antd"

import { Modal } from "@components/Page"


const ProgressModal = ({
  percent = null,
  renderFilters = null,
  stop,
  reset,
  title,
  modal,
  start,
}) => {
  const [ isOpen, setIsOpen ] = useState(false)

  const hasFilters = renderFilters !== null

  const onClose = () => {
    setIsOpen(false)
    stop()
    reset()
  }

  modal.current.close = () =>
    onClose()

  modal.current.open = (...parameters) => {
    setIsOpen(true)

    if (!hasFilters) {
      start(...parameters)
    }
  }

  const modalProps = {
    destroyOnClose: true,
    title,
    isOpen,
    onClose,
  }

  const hasStarted = percent !== null

  let content = <Progress percent={percent} />
  const shouldRenderFilters = hasFilters && !hasStarted

  if (shouldRenderFilters) {
    content = renderFilters()
  }

  return (
    <Modal {...modalProps}>
      {content}
    </Modal>
  )
}

ProgressModal.propTypes = {
  stop: PropTypes.func.isRequired,
  start: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  modal: PropTypes.shape().isRequired,
  percent: PropTypes.number,
  renderFilters: PropTypes.func,
}

export default ProgressModal
